var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngineOil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.166 3.684c.149.126.06-.156.409-.15.233.003.427.059.582.166l5.085 2.334.347-.779-1.579-.703c-.254-.113-.374-.397-.269-.634l.49-1.098c.105-.238.397-.338.65-.225l4.35 1.936c.254.113.374.398.269.635l-.49 1.098c-.105.237-.397.338-.65.225l-1.636-.728-.347.778 5.675 2.457c.34.151.5.53.36.847l-.329.737 4.982-.792 2.453 1.092-.41.923-1.476-.657L19.03 13.6c-.176.228-2.043 4.015-2.335 3.885L4.303 12.28c-.34-.151-.5-.53-.359-.846l3.222-7.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.5 12c2 4 2 6 0 6s-2-2 0-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 6.568L2.632 1.542.799 7.612 5.53 10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineOil);
export default __webpack_public_path__ + "static/media/engine_oil.230a0d2f6094f41cd559ee8bf8e873b8.svg";
export { ForwardRef as ReactComponent };